const version2 = [
    //借款申请第二版

    {
      path: '/h5version/home',
      component: () => import('@/pages/h5version/home.vue'),
      meta: {
        title: '首页',
        keepAlive: false,
        notLogin:true,//不需要登录页面
      }
    },
    {
      path: '/h5version/login',
      component: () => import('@/pages/h5version/login.vue'),
      meta: {
        title: '登录',
        keepAlive: false,
        notLogin:true
      }
    },
    {
      path: '/h5version/my',
      component: () => import('@/pages/h5version/my.vue'),
      meta: {
        title: '我的',
        keepAlive: false
      }
    },
    {
      path: '/h5version/setting',
      component: () => import('@/pages/h5version/setting.vue'),
      meta: {
        title: '设置',
        keepAlive: false
      }
    },
    {
      path: '/h5version/ocr',
      component: () => import('@/pages/h5version/ocr.vue'),
      meta: {
        title: '实名认证',
        keepAlive: false
      }
    },
    {
      path: '/h5version/base-info',
      component: () => import('@/pages/h5version/base-info.vue'),
      meta: {
        title: '个人信息',
        keepAlive: false
      }
    },
    {
      path: '/h5version/person-contact',
      component: () => import('@/pages/h5version/person-contact.vue'),
      meta: {
        title: '联系人信息',
        keepAlive: false
      }
    },
    {
      path: '/h5version/face',
      component: () => import('@/pages/h5version/face.vue'),
      meta: {
        title: '人脸识别',
        keepAlive: false
      }
    },
    {
      path: '/h5version/match-loading',
      component: () => import('@/pages/h5version/match-loading.vue'),
      meta: {
        title: '申请中',
        keepAlive: false
      }
    },

    {
      path: '/h5version/navbill',
      component: () => import('@/pages/h5version/navbill.vue'),
      meta: {
        title: '账单',
        keepAlive: false
      }
    },

    {
      path: '/h5version/result-page-fail',
      component: () => import('@/pages/h5version/result-page-fail.vue'),
      meta: {
        title: '审核中',
        keepAlive: false
      }
    },
    {
      path: '/h5version/result-page-review',
      component: () => import('@/pages/h5version/result-page-review.vue'),
      meta: {
        title: '审核中',
        keepAlive: false
      }
    },
    {
      path: '/h5version/result-page-success',
      component: () => import('@/pages/h5version/result-page-success.vue'),
      meta: {
        title: '审核中',
        keepAlive: false
      }
    },
    {
      path: '/h5version/loan-result',
      component: () => import('@/pages/h5version/loan-result.vue'),
      meta: {
        title: '放款中',
        keepAlive: false
      }
    },


  ]
export default version2



// WEBPACK FOOTER //
// ./src/router/modules/h5version.js